import React from 'react';
import Row from '@sp/ui/base/rows/Row';

const OneLineRow = (props) => <Row {...props} minHeight={46} />;

export default OneLineRow;
